import { render, staticRenderFns } from "./ReturnChangePrice.vue?vue&type=template&id=2f6964fa&scoped=true"
import script from "./ReturnChangePrice.vue?vue&type=script&lang=js"
export * from "./ReturnChangePrice.vue?vue&type=script&lang=js"
import style0 from "./ReturnChangePrice.vue?vue&type=style&index=0&id=2f6964fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6964fa",
  null
  
)

export default component.exports